
export const ModeScreen = () => `
        <div id="mode-screen" class="screen">
            <h2 class="screen-title">KADERİNİ SEÇ</h2>
            <div class="mode-options">
                <button class="gaddar-btn mode-btn" data-mode="sureli">
                    🔥 GADDAR MOD (SÜRELİ)
                    <small>Hata affetmez. Zaman akar.</small>
                </button>
                <button class="gaddar-btn mode-btn" data-mode="suresiz">
                    🧘 RAHAT MOD (SÜRESİZ)
                    <small>Düşünmek için vaktin var.</small>
                </button>
            </div>
        </div>
`;
